import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/Blogs/blogsSlice";
import PostItem from "./PostItem";

export default function Posts() {
  const { allPosts, sort, filter } = useSelector((state) => state.blogs);
  const dispatch = useDispatch();

  // Apply sorting
  let sortedPosts = [...allPosts];
  if (sort === "newest") {
    sortedPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  } else if (sort === "most_liked") {
    sortedPosts.sort((a, b) => b.likes - a.likes);
  }

  // Apply filtering
  let filteredPosts = sortedPosts;
  if (filter === "saved") {
    filteredPosts = sortedPosts.filter((post) => post.isSaved);
  }

  useEffect(() => {
    dispatch(fetchBlogs());
  }, []);

  return (
    <main className="post-container" id="lws-postContainer">
      {filteredPosts.map((post) => (
        <PostItem key={post.id} post={post} />
      ))}
    </main>
  );
}
